// ============================================================================
// equipment.checklist.entry — migrated off the global read
// ============================================================================
// The checklist entry record at /fleet/checklist/<id>, mounted by EquipmentHome from the same container read.
//
// Four EquipmentHome surfaces share the single `equipment.fleet.core` resource because
// they are four renders of ONE container load, not four independent reads.
// That is still exactly one owner per surface: the catalog resource lists all
// four in its `surfaces` array, and the manifest/catalog/receipt equality
// carries the multiplicity as four distinct (surface, resource) pairs rather
// than collapsing them into one.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'equipment.checklist.entry',
  obligations: Object.freeze([Object.freeze({id: 'equipment.fleet.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
